"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILWeekdaySelectorWithContextExample = exports.ILWeekdaySelectorWithContext = void 0;
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var providers_1 = require("../../providers");
var il_weekday_selector_1 = require("./il-weekday.selector");
function ILWeekdaySelectorWithContext(_a) {
    var onChange = _a.onChange, props = __rest(_a, ["onChange"]);
    var ctx = react_1.default.useContext(providers_1.ILCalendarContext);
    if (!ctx || !(ctx === null || ctx === void 0 ? void 0 : ctx.selectedDate)) {
        throw new Error("Must be inside 'ILCalendarProvider'");
    }
    return (react_1.default.createElement(il_weekday_selector_1.ILWeekdaySelector, __assign({}, props, { onChange: function (date) {
            ctx.changeSelectedDate(date);
            onChange && onChange(date);
        }, selectedDate: ctx.selectedDate })));
}
exports.ILWeekdaySelectorWithContext = ILWeekdaySelectorWithContext;
function DisplayCtxValues() {
    var ctx = react_1.default.useContext(providers_1.ILCalendarContext);
    return (react_1.default.createElement("div", { "data-testid": "date-selector" }, "SelectedDate: ".concat((0, date_fns_1.format)(ctx.selectedDate, 'LLLL dd, yyyy'))));
}
function ILWeekdaySelectorWithContextExample(_a) {
    var children = _a.children, onChange = _a.onChange, defaultContext = _a.defaultContext, props = __rest(_a, ["children", "onChange", "defaultContext"]);
    return (react_1.default.createElement(material_1.Box, { sx: { m: 2, p: 2 } },
        react_1.default.createElement(providers_1.ILCalendarProvider, { defaultContext: defaultContext },
            react_1.default.createElement(ILWeekdaySelectorWithContext, __assign({ onChange: onChange }, props)),
            react_1.default.createElement(DisplayCtxValues, null),
            children)));
}
exports.ILWeekdaySelectorWithContextExample = ILWeekdaySelectorWithContextExample;
